import React from 'react'
import { useSelector } from 'react-redux'
import Popup from 'reactjs-popup'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const MaskMenuContainer = styled.div`
	border: 2px solid black;
	background-color: #ffffff;
	min-width: 100px;
	overflow: auto;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
	z-index: 1;
	border-radius: 8px;
`

const MaskMenuItem = styled.div`
	padding: 0px 20px;
	display: block;
	cursor: pointer;
	font-weight: 600;
	font-size: 13px;
	line-height: 30px;
	margin: 0px !important;
	text-decoration: none;
	color: black;
`

export default function MaskDropdown({
	trigger,
	borderColor,
	backgroundColor,
	style,
	hideOption = -1,
}) {
	const navigate = useNavigate()
	const pex = useSelector((state) => state.user.value.pex)
	const [focusedLink, setFocusedLink] = React.useState(-1)

	const hover = {
		backgroundColor,
	}

	function onClick(link) {
		navigate(link)
	}

	return (
		<Popup trigger={trigger} position={'bottom center'}>
			<MaskMenuContainer style={{ ...style, borderColor }}>
				{pex.read_owner && hideOption != 0 && (
					<MaskMenuItem
						onClick={() => onClick('/inputMask/owner')}
						onMouseOver={() => setFocusedLink(0)}
						onMouseOut={() => setFocusedLink(-1)}
						style={focusedLink == 0 ? hover : {}}
					>
						{' '}
						Besitzer
					</MaskMenuItem>
				)}
				{pex.read_artist && hideOption != 1 && (
					<MaskMenuItem
						onClick={() => onClick('/inputMask/artist')}
						onMouseOver={() => setFocusedLink(1)}
						onMouseOut={() => setFocusedLink(-1)}
						style={focusedLink == 1 ? hover : {}}
					>
						Künstler
					</MaskMenuItem>
				)}
				{pex.read_artwork && hideOption != 2 && (
					<MaskMenuItem
						onClick={() => onClick('/inputMask/artwork')}
						onMouseOver={() => setFocusedLink(2)}
						onMouseOut={() => setFocusedLink(-1)}
						style={focusedLink == 2 ? hover : {}}
					>
						Werke
					</MaskMenuItem>
				)}
				{pex.read_artwork && hideOption != 3 && (
					<MaskMenuItem
						onClick={() => onClick('/filterartwork')}
						onMouseOver={() => setFocusedLink(3)}
						onMouseOut={() => setFocusedLink(-1)}
						style={focusedLink == 3 ? hover : {}}
					>
						Suchen
					</MaskMenuItem>
				)}
			</MaskMenuContainer>
		</Popup>
	)
}
